import React from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import AuthRoute from 'utils/auth/authRoute';

import TemplatesTabs from 'pages/emails/templates';
import { TemplatesList, TemplateInformation } from 'pages/emails/templates/templates';
import { BrandKit, BrandKitsList } from 'pages/emails/templates/brandkits';
import TemplateEdition from '../../pages/emails/templates/templates/TemplateEdition';

export const TemplatesRouter = ({ match }) => {
    const { path, url } = match;

    return (
        <Switch>
            <Route
                exact
                path={`${path}/`}
                render={() => {
                    let redirect = `${url}/templates`;
                    if (url[url.length - 1] === '/') {
                        redirect = `${url}templates`;
                    }
                    return <Redirect to={redirect} />;
                }}
            />

            <AuthRoute
                exact
                path={`${path}/templates`}
                allow={['EmailCapacity.TEMPLATE_ADMIN', 'EmailCapacity.TEMPLATE']}
                render={basenameProps => {
                    const { organizationId } = basenameProps.match.params;
                    return (
                        <TemplatesTabs organizationId={organizationId} path={basenameProps.match.path} index={0}>
                            <TemplatesList />
                        </TemplatesTabs>
                    );
                }}
            />
            <AuthRoute
                exact
                path={`${path}/templates/:id`}
                allow={['EmailCapacity.TEMPLATE_ADMIN', 'EmailCapacity.TEMPLATE']}
                render={basenameProps => {
                    const { id, organizationId } = basenameProps.match.params;
                    return <TemplateInformation id={id} organizationId={organizationId} />;
                }}
            />
            <AuthRoute
                exact
                path={`${path}/templates/:id/edit`}
                allow={['EmailCapacity.TEMPLATE_ADMIN', 'EmailCapacity.TEMPLATE']}
                render={basenameProps => {
                    const { id, organizationId } = basenameProps.match.params;
                    return <TemplateEdition id={id} organizationId={organizationId} />;
                }}
            />

            <AuthRoute
                exact
                path={`${path}/brandkits`}
                allow={['PyvarCapacity.DEV']}
                render={basenameProps => {
                    const { organizationId } = basenameProps.match.params;
                    return (
                        <TemplatesTabs organizationId={organizationId} path={basenameProps.match.path} index={1}>
                            <BrandKitsList />
                        </TemplatesTabs>
                    );
                }}
            />
            <AuthRoute
                exact
                path={`${path}/brandkits/new`}
                allow={['PyvarCapacity.DEV']}
                render={basenameProps => {
                    const { organizationId } = basenameProps.match.params;
                    return <BrandKit organizationId={organizationId} />;
                }}
            />
            <AuthRoute
                exact
                path={`${path}/brandkits/:id`}
                allow={['PyvarCapacity.DEV']}
                render={basenameProps => {
                    const { id, organizationId } = basenameProps.match.params;
                    return <BrandKit id={id} organizationId={organizationId} />;
                }}
            />
        </Switch>
    );
};
